// The bare root page. Nothing on this site is reachable without a one-time
// invitation link, so this is a static, bilingual dead end (both languages
// at once — there is nothing else here to toggle).

import { Card, CardBody } from "@/components/ui/card";
import { Page } from "@/components/page";
import { ThemeToggle } from "@/components/theme-toggle";

export function HomePage() {
  return (
    <Page className="flex min-h-[70vh] flex-col">
      {/* No language pill here (the card shows both languages at once), but
          the theme toggle keeps its top-right spot like every other screen. */}
      <div className="mb-6 flex justify-end">
        <ThemeToggle />
      </div>
      <div className="flex flex-1 items-center">
        <Card className="w-full">
          <CardBody className="space-y-4 py-8 text-center">
            <p className="text-[11px] font-medium uppercase tracking-[0.18em] text-ink-muted">
              AGP · Big Five
            </p>
            <div className="space-y-1">
              <h1 className="font-serif text-2xl">Access requires an invitation link.</h1>
              <p className="text-sm text-ink-muted">
                If you received an invitation email, open the personal link inside it.
              </p>
            </div>
            <div className="space-y-1" lang="ja">
              <h2 className="font-serif text-xl">このページの閲覧には招待リンクが必要です。</h2>
              <p className="text-sm text-ink-muted">
                招待メールが届いている場合は、メール内の専用リンクを開いてください。
              </p>
            </div>
          </CardBody>
        </Card>
      </div>
    </Page>
  );
}
